//# sourceMappingURL=ai_search.mjs.map
/// <reference types="./ai_search.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $client from "../../../auth0_client/auth0/client.mjs";
import * as $ai_config from "../../../data_types/data/ai_config.mjs";
import * as $data_point from "../../../data_types/data/data_point.mjs";
import * as $data_source from "../../../data_types/data/data_source.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $weaviate from "../../../data_types/data/weaviate.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $result_ from "../../../tiamat/gleam/result_.mjs";
import * as $store from "../../data/store.mjs";
import { Error, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class DataPointResult extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const SearchResult$DataPointResult = ($0) => new DataPointResult($0);
export const SearchResult$isDataPointResult = (value) =>
  value instanceof DataPointResult;
export const SearchResult$DataPointResult$0 = (value) => value[0];

export class DataSourceResult extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const SearchResult$DataSourceResult = ($0) => new DataSourceResult($0);
export const SearchResult$isDataSourceResult = (value) =>
  value instanceof DataSourceResult;
export const SearchResult$DataSourceResult$0 = (value) => value[0];

function search_response_decoder() {
  return $decode.list(
    $decode.field(
      "search_result",
      $decode.one_of(
        $decode.map(
          $data_point.decoder(),
          (var0) => { return new DataPointResult(var0); },
        ),
        toList([
          $decode.map(
            $data_source.decoder(),
            (var0) => { return new DataSourceResult(var0); },
          ),
        ]),
      ),
      (search_result) => {
        return $decode.field(
          "score",
          $decode.float,
          (score) => { return $decode.success([search_result, score]); },
        );
      },
    ),
  );
}

export function query_search(store, org_id, kind, variant, query) {
  let token = $client.get_token_silently(store.client);
  return $promise.try_await(
    token,
    (access_token) => {
      let default$ = () => { return $promise.resolve(new Error(undefined)); };
      let ai_config = $store.organization_ai_config(store);
      return $when.ok_(
        $remote.read(ai_config),
        default$,
        (ai_config) => {
          return $when.some_(
            store.user,
            default$,
            (user) => {
              let _pipe = $ask.to(new $ask.Nabu(), toList(["admin", "search"]));
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
              let _pipe$3 = $ask.with$(
                _pipe$2,
                $json.object(
                  toList([
                    ["org_id", $json.string(org_id)],
                    ["kind", $json.string($weaviate.kind_to_string(kind))],
                    [
                      "variant",
                      $json.string($weaviate.variant_to_string(variant)),
                    ],
                    ["query", $json.string(query)],
                    ["config", $ai_config.encode_config(ai_config.config)],
                    ["user_id", $json.string(user.sub)],
                  ]),
                ),
              );
              let _pipe$4 = $ask.expect(_pipe$3, search_response_decoder());
              let _pipe$5 = $ask.run(_pipe$4);
              return $promise.map(_pipe$5, $result_.nil_error);
            },
          );
        },
      );
    },
  );
}

export function list_n_objects(store, org_id, collection_kind, variant, n) {
  let token = $client.get_token_silently(store.client);
  return $promise.try_await(
    token,
    (access_token) => {
      let _pipe = $ask.to(
        new $ask.Nabu(),
        toList(["admin", "weaviate", "collection"]),
      );
      let _pipe$1 = $ask.bearing(_pipe, access_token);
      let _pipe$2 = $ask.via(_pipe$1, new $http.Get());
      let _pipe$3 = $ask.query(_pipe$2, "org_id", org_id);
      let _pipe$4 = $ask.query(
        _pipe$3,
        "collection_kind",
        $weaviate.kind_to_string(collection_kind),
      );
      let _pipe$5 = $ask.query(
        _pipe$4,
        "variant",
        $weaviate.variant_to_string(variant),
      );
      let _pipe$6 = $ask.query(_pipe$5, "n", $int.to_string(n));
      let _pipe$7 = $ask.expect(_pipe$6, search_response_decoder());
      let _pipe$8 = $ask.run(_pipe$7);
      return $promise.map(_pipe$8, $result_.nil_error);
    },
  );
}
